import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { LoadingSpinner } from '@/components/common/LoadingSpinner'
import { getMatch } from '@/services/firebase'
import { ScoringScreen } from './ScoringScreen'
import { TennisScoringScreen } from './TennisScoringScreen'

export const MatchLoader: React.FC = () => {
  const location = useLocation()
  const [matchData, setMatchData] = useState<any>(null)
  const [error, setError] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    setError(null)
    const searchParams = new URLSearchParams(location.search)
    const matchId = searchParams.get('matchId')

    if (matchId) {
      setIsLoading(true)
      getMatch(matchId)
        .then((data) => {
          if (data) {
            setMatchData(data)
          } else {
            setError('Match not found')
          }
        })
        .catch((err) => {
          console.error('Error loading match:', err)
          setError('Error loading match')
        })
        .finally(() => {
          setIsLoading(false)
        })
    } else {
      setIsLoading(false)
    }
  }, [location.search])

  if (isLoading) {
    return <LoadingSpinner />
  }

  if (error) {
    return (
      <div style={{ 
        color: 'red.600', 
        backgroundColor: 'red.100', 
        padding: '12px', 
        marginBottom: '16px', 
        borderRadius: '6px', 
        maxWidth: '32rem', 
        margin: '0 auto', 
        textAlign: 'center' 
      }}>
        {error}
      </div>
    )
  }

  if (!matchData) {
    return <LoadingSpinner />
  }

  // Determine if user is a controller based on URL token parameter
  const searchParams = new URLSearchParams(location.search)
  const isController = !!searchParams.get('token')

  // Render appropriate scoring screen based on match structure
  if (matchData.scoringStructure === 'tennis') {
    return (
      <TennisScoringScreen
        matchId={matchData.id}
        team1Color={matchData.team1Color || 'red'}
        team2Color={matchData.team2Color || 'blue'}
        isController={isController}
        team1Name={matchData.team1Name}
        team2Name={matchData.team2Name}
        showQRCode={matchData.showQRCode !== false}
        courtNumber={matchData.courtNumber}
      />
    )
  } else {
    return (
      <ScoringScreen
        matchId={matchData.id}
        team1Color={matchData.team1Color || 'red'}
        team2Color={matchData.team2Color || 'blue'}
        isController={isController}
        team1Name={matchData.team1Name}
        team2Name={matchData.team2Name}
        showQRCode={matchData.showQRCode !== false}
        courtNumber={matchData.courtNumber}
      />
    )
  }
} 